import React, { useState } from 'react';
import Modal from './Modal';

const VARIANTS = {
  primary: {
    backgroundColor: 'var(--color-primary)',
    color: 'var(--color-text-on-brand)',
    border: '1px solid transparent',
  },
  secondary: {
    backgroundColor: 'transparent',
    color: 'var(--color-ink)',
    border: '1px solid var(--color-border)',
  },
  ghost: {
    backgroundColor: 'transparent',
    color: 'var(--color-ink-soft)',
    border: '1px solid transparent',
  },
  danger: {
    backgroundColor: 'var(--color-danger)',
    color: '#fff',
    border: '1px solid transparent',
  },
};

/** Shared button for every dashboard. Pass `confirmMessage` on a destructive
 * action (Reject/Delete/Vacate/...) and Button handles the confirmation
 * dialog itself — callers don't need their own window.confirm(). */
function Button({
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconPosition = 'left',
  disabled,
  confirmMessage,
  confirmTitle = 'Are you sure?',
  onClick,
  children,
  style,
  type = 'button',
  ...rest
}) {
  const [confirming, setConfirming] = useState(false);
  const padding = size === 'sm' ? '7px 14px' : '10px 18px';
  const fontSize = size === 'sm' ? '13px' : '14px';

  function handleClick(e) {
    if (confirmMessage) {
      setConfirming(true);
      return;
    }
    onClick?.(e);
  }

  return (
    <>
      <button
        type={type}
        className="btn-lift"
        disabled={disabled}
        onClick={handleClick}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          padding,
          fontSize,
          fontWeight: 600,
          borderRadius: '10px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          whiteSpace: 'nowrap',
          ...VARIANTS[variant],
          ...style,
        }}
        {...rest}
      >
        {Icon && iconPosition === 'left' && <Icon size={16} />}
        {children}
        {Icon && iconPosition === 'right' && <Icon size={16} />}
      </button>

      {confirming && (
        <Modal title={confirmTitle} onClose={() => setConfirming(false)} width="400px">
          <p style={{ fontSize: '14px', color: 'var(--color-ink-soft)', lineHeight: 1.5, margin: '0 0 20px' }}>
            {confirmMessage}
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <Button variant="secondary" onClick={() => setConfirming(false)}>Cancel</Button>
            <Button
              variant="danger"
              onClick={(e) => {
                setConfirming(false);
                onClick?.(e);
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
}

export default Button;
